'use client';

import { c as _c } from "react/compiler-runtime";
import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useParams, usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useScroll from '../hooks/useScroll';
import { useViewport } from '../hooks/useViewport';
const ScrollHelperBlackVisual = () => {
  const $ = _c(13);
  const dispatch = useDispatch();
  const {
    floorId,
    houseId,
    bulkId
  } = useParams();
  const {
    scrollY
  } = useScroll();
  const {
    isMobile
  } = useViewport();
  const pathname = usePathname();
  let t0;
  if ($[0] !== bulkId || $[1] !== dispatch || $[2] !== floorId || $[3] !== houseId || $[4] !== isMobile) {
    t0 = () => {
      setTimeout(() => {
        if (isMobile && houseId && bulkId && !floorId) {
          dispatch(handleHeaderColorScheme("whiteOnTransparent"));
        } else {
          dispatch(handleHeaderColorScheme("blackOnTransparentThree"));
        }
      }, 300);
    };
    $[0] = bulkId;
    $[1] = dispatch;
    $[2] = floorId;
    $[3] = houseId;
    $[4] = isMobile;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== pathname) {
    t1 = [pathname];
    $[6] = pathname;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
  let t2;
  if ($[8] !== dispatch || $[9] !== scrollY) {
    t2 = () => {
      if (scrollY < 3000) {
        dispatch(handleHeaderColorScheme("blackOnTransparentThree"));
      } else {
        dispatch(handleHeaderColorScheme(""));
      }
    };
    $[8] = dispatch;
    $[9] = scrollY;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== scrollY) {
    t3 = [scrollY];
    $[11] = scrollY;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useEffect(t2, t3);
  return null;
};
export default ScrollHelperBlackVisual;